import { Identifiable, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditRequest(
  zone: Identifiable<Zone>,
  { nextZone, zone: z }: Boundaries["editZone"]["request"],
): Identifiable<Zone> {
  return z.uuid === zone.uuid ? { ...zone, ...nextZone } : zone;
}

function handleEditSuccess(
  zone: Identifiable<Zone>,
  nextZone: Boundaries["editZone"]["success"],
): Identifiable<Zone> {
  return nextZone.uuid === zone.uuid ? { ...zone, ...nextZone } : zone;
}

function handleEditFailure(
  zone: Identifiable<Zone>,
  { zone: z }: Boundaries["editZone"]["failure"],
): Identifiable<Zone> {
  return z.uuid === zone.uuid ? z : zone;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
